import { render, staticRenderFns } from "./RH35.vue?vue&type=template&id=315a42a2&scoped=true"
import script from "./RH35.vue?vue&type=script&lang=js"
export * from "./RH35.vue?vue&type=script&lang=js"
import style0 from "./RH35.vue?vue&type=style&index=0&id=315a42a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a42a2",
  null
  
)

export default component.exports